function isSSR() {
  return typeof window === 'undefined';
}

export { isSSR };
//# sourceMappingURL=ssr.esm.js.map
